import { create } from 'zustand';
import i18n from 'i18n';
import { RegisterApi, RestApiError, StatusCodeEnum, type RegisterFirstRequest } from '@shared/api';
import { AuthUtils } from '@shared/utils';
import type { BaseReturn } from '@shared/types';

interface UseRegisterFirstStore {
  loading: boolean;
  data: any;
  error?: string | null;
  registerFirst: (request: RegisterFirstRequest) => Promise<BaseReturn<any>>;
  clear: () => void;
}

export const useRegisterFirstStore = create<UseRegisterFirstStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  registerFirst: async (request) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await RegisterApi.registerFirst(request);
      AuthUtils.setRegisterTempToken(result.registerToken);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_UNAUTHORIZED:
          errorMessage = 'Incorrect card number or mobile number';
          break;
        case StatusCodeEnum.API_ERROR_FORBIDDEN:
          errorMessage = Array.isArray(restError?.data) && restError?.data?.[0] ? restError?.data?.[0] : 'Forbidden';
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
